import { useEffect } from "react";
import { AssociaDistribuidor } from "src/framework/layouts/Main/AssociaDistribuidor";
import { appStore } from "src/framework/store/AppStore";

const PAGE_TITLE = "Associar Distribuidor"

const AssociaDistribuidorPage = () => {
  useEffect(() => {
    appStore.setPageTitle(PAGE_TITLE);
    return () => {
      appStore.setPageTitle("");
    }
  }, [])

  return (
    <div className="container">
      <div className="row">
        <div className="X12">
          <AssociaDistribuidor />
        </div>
      </div>
    </div>
  );
};

export { AssociaDistribuidorPage };